import { User } from "oidc-client";
import React, { FunctionComponent, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { setLoggedInUser } from "../../domain/Auth/authSlice";
import { useAppDispatch } from "../../store/hooks";
import userManager from "../../utils/userManager";

export const Callback: FunctionComponent = () => {

    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        userManager.signinRedirectCallback()
            .then((user) => successCallback(user))
            .catch((err) => {
                const message = err instanceof Error ? err.message : String(err);

                if (message.includes("No matching state")) {
                    console.warn("OIDC callback invoked but no state was found. Possibly a direct load of /callback.");
                    navigate("/login");
                    return;
                }

                const wrapped = new Error(`OIDC signinRedirectCallback failed: ${message}`);
                errorCallback(wrapped);
            });
    }, []);

    const successCallback = async (user: User) => {
        dispatch(setLoggedInUser(user));
        navigate("/");
    };

    const errorCallback = (error: Error) => {
        console.error(error);
    };

    return (
        <div>&#x231B;</div>
    );
};
